import { render, staticRenderFns } from "./payment-page-navigation.vue?vue&type=template&id=4c0ed49c&scoped=true"
import script from "./payment-page-navigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-page-navigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./payment-page-navigation.vue?vue&type=style&index=0&id=4c0ed49c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ed49c",
  null
  
)

export default component.exports